<template>
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else style="max-width: 600px;">
    <b-form-radio-group
      v-model="selectedPM"
      :options="formData.pmList"
      style="width: 100%;"
      value-field="name"
      text-field="name"
      buttons
      button-variant="outline-primary"
      disabled-field="disabled">
    </b-form-radio-group>
    <div v-for="pm, i in formData.pmList" :key="i">
      <div v-if="selectedPM === pm.name">
        <div>{{ pm.text }}:</div>
        <div v-if="pm.type === pmtd.COUPON">
          <b-form-input
            id="id-coupon-field"
            v-model="formData.coupon"
            type="text"
            required
            style="max-width: 300px;"
            placeholder="coupon"/>
        </div>
        <div v-show="pm.type === pmtd.PREF_PAYM_PROVIDER"
          id="glcwc-stripe-payment-widget" ref="prefPaymProvRef">
          <div id="stripe-card-element"></div>
          <div id="stripe-card-errors" role="alert" style="color: red;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
// import * as htmlUtil from '@/service/utils/html'
import { PIT_DEFS } from '@/service/utils/constants'
import { PAYM_METHOD_TYPE_DEFS as PMTD } from '@/service/utils/constants'

export default {
  name: 'gl-payment-widget',
  version: '0.0.1',
  props: {
    contentKey: {
      type: String,
      required: true
    }, // contentKey
    paymInstKey: {
      type: String,
      required: false
    } // paymInstKey
  }, // props
  components: {}, // components
  data () {
    return {
      pmtd: PMTD,
      selectedPM: null,
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      formData: {
        coupon: ''
      },
      stripe: {
        inst: null,
        elements: null,
        card: null,
        cardValid: false,
        cardMounted: false
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted () {
    this.loaded = false
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)

      const _contentData = resp.data.payload.content
      this.formData = _contentData.fragments
      this.selectedPM = this.formData.pmList[0]?.name

      console.log('TRACE-REMOVE: paymInstKey is: ', this.paymInstKey)
      console.log('TRACE-REMOVE: hasPrefPaymProvider is: ', this.hasPrefPaymProvider())
      if (this.paymInstKey && this.hasPrefPaymProvider()) {
        const _glapiPaymResp = await axios.get(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/preferedPIDetails')

        if ('success' === _glapiPaymResp.data.status) {
          this.piType = _glapiPaymResp.data.payload.ppiDetails.piType
          this.piMerchantId = _glapiPaymResp.data.payload.ppiDetails.merchantId
          if (this.piType === PIT_DEFS.pitStripe) {
            // this.loadStripeSdk()
            // this.mountStripeElements()
          } else {
            throw new Error('Payment integration [' + this.piType + '] not supported!')
          }
        } else {
          throw new Error('Payment API call failed! Status: ' + _glapiPaymResp.data)
        }
      }

      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  updated () {
    const pm = this.formData.pmList.find((el) => el.name === this.selectedPM)
    console.log('TRACE-REMOVE: PaymentWidget.updated: pm is: ', pm)
    // if (pm && pm.type === PMTD.PREF_PAYM_PROVIDER && !this.stripe.cardMounted) {
    if (pm && pm.type === PMTD.PREF_PAYM_PROVIDER) {
      // this.mountStripeCardEl()
      this.loadStripeSdk()
    }
  }, // updated
  computed: {}, // computed
  watch: {}, // watch
  methods: {
    /* ----- public methods ----- */
    getStripe () {
      return this.stripe
    }, // getStripe
    getSelectedPM () {
      return this.formData.pmList.find((el) => el.name === this.selectedPM)
    }, // getStripe
    /* ----- utility methods ----- */
    loadStripeSdk () {
      console.log('INFO: loading StripeSdk ...')
      const script = document.createElement('script')
      script.src = config.stripeSdkUrl
      script.async = false
      script.addEventListener('load', () => {
        // eslint-disable-next-line
        this.stripe.inst = Stripe(config.stripePlatformPK, {
          apiVersion: '2020-08-27',
          stripeAccount: this.piMerchantId
        })
        this.stripe.elements = this.stripe.inst.elements()
        this.stripe.card = this.stripe.elements.create('card')
        // card.mount('#card-element');
        console.log('INFO: StripeSdk loaded!')
        this.stripe.card.mount('#stripe-card-element')
        this.stripe.card.on('change', ({ complete, error }) => {
          let displayError = document.getElementById('stripe-card-errors')
          if (error) {
            this.stripe.cardValid = false
            displayError.textContent = error.message
          } else if (complete) {
            this.stripe.cardValid = true
            displayError.textContent = ''
          } else {
            this.stripe.cardValid = false
            displayError.textContent = ''
          }
        })
        this.stripe.cardMounted = true
        console.log('INFO: Stripe card mounted!')
      })
      document.body.appendChild(script)
    }, // loadStripeSdk
    mountStripeCardEl () {
      this.stripe.card.mount('#stripe-card-element')
      this.stripe.card.on('change', ({ complete, error }) => {
        let displayError = document.getElementById('stripe-card-errors')
        if (error) {
          this.stripe.cardValid = false
          displayError.textContent = error.message
        } else if (complete) {
          this.stripe.cardValid = true
          displayError.textContent = ''
        } else {
          this.stripe.cardValid = false
          displayError.textContent = ''
        }
      })
    }, // mountStripeCardEl
    hasPrefPaymProvider () {
      var _ret = false
      if (this.formData.pmList &&
        this.formData.pmList.some((pm) => pm.type === PMTD.PREF_PAYM_PROVIDER)) {
        _ret = true
      }
      return _ret
    }
  } // methods
}
</script>

<style lang="scss" scoped>
</style>
